import React,{Component} from 'react';

class MapLocationListItem extends Component{

  constructor(props){
    super(props);
    this.showMapLocation = this.showMapLocation.bind(this);
    
  }
  showMapLocation() {
    this.props.showMapLocation(this.props.location.location);
  }
  render(){

    console.log(this.props.location);
    const time = this.props.location != null ? new Intl.DateTimeFormat("fi-FI", {hour: "2-digit",minute: "2-digit"}).format(new Date(this.props.location.locationUpdateTime)) : "";
     
      return (
        
        <li onClick={this.showMapLocation}>Klo: &nbsp;{time}</li>
      )
   
  }
}
export default MapLocationListItem;
